export default __webpack_public_path__ + "static/media/done.6cef7f6f.jpg";